import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../auth";
import api from "../api";

const ROLE_COLORS={admin:{bg:"#EDE9FE",color:"#5B21B6"},hr:{bg:"#DBEAFE",color:"#1D4ED8"},
  manager:{bg:"#FEF3C7",color:"#92400E"},team_member:{bg:"#F0FDF4",color:"#166534"}};
const ROLE_LABEL={admin:"Admin",hr:"HR",manager:"Manager",team_member:"Team Member"};

function TeamAvatar({emp,size=52}){
  const [photo,setPhoto]=useState(null);
  const ref=useRef(null);
  const initials=n=>(n||"?").split(" ").slice(0,2).map(w=>w[0]).join("").toUpperCase();
  useEffect(()=>{
    const obs=new IntersectionObserver(([e])=>{
      if(!e.isIntersecting)return; obs.disconnect();
      fetch(`/api/portal/photo?emp=${emp.employee_id}`,{
        headers:{Authorization:`Bearer ${sessionStorage.getItem("iws_token")}`}})
        .then(r=>r.ok?r.blob():null).then(b=>b&&setPhoto(URL.createObjectURL(b))).catch(()=>{});
    },{threshold:0.1});
    if(ref.current)obs.observe(ref.current);
    return()=>obs.disconnect();
  },[emp.employee_id]);
  return(
    <div ref={ref} style={{width:size,height:size,borderRadius:"50%",flexShrink:0,overflow:"hidden",
      background:photo?"transparent":"var(--accent)",color:"#fff",display:"flex",
      alignItems:"center",justifyContent:"center",fontWeight:700,fontSize:size*0.35}}>
      {photo?<img src={photo} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}}/>:initials(emp.name)}
    </div>
  );
}

function EmpProfileModal({empId,name,onClose}){
  const [data,setData]=useState(null);
  const [photo,setPhoto]=useState(null);

  useEffect(()=>{
    api.get(`/portal/admin/employee/${empId}/extended`)
      .then(d=>setData(d)).catch(()=>{});
    fetch(`/api/portal/photo?emp=${empId}`,{
      headers:{Authorization:`Bearer ${sessionStorage.getItem("iws_token")}`}})
      .then(r=>r.ok?r.blob():null).then(b=>b&&setPhoto(URL.createObjectURL(b))).catch(()=>{});
  },[empId]);

  const Row=({label,value})=>value?(
    <div style={{display:"flex",justifyContent:"space-between",padding:"7px 0",borderBottom:"1px solid var(--line)"}}>
      <span style={{color:"var(--muted)",fontSize:13,minWidth:130}}>{label}</span>
      <span style={{fontSize:13,textAlign:"right"}}>{value}</span>
    </div>
  ):null;

  return(
    <div onClick={e=>e.target===e.currentTarget&&onClose()}
      style={{position:"fixed",inset:0,background:"rgba(0,0,0,.5)",zIndex:9999,
        display:"flex",alignItems:"center",justifyContent:"center",padding:16}}>
      <div style={{background:"#fff",borderRadius:14,maxWidth:520,width:"100%",
        maxHeight:"90vh",display:"flex",flexDirection:"column",overflow:"hidden",
        boxShadow:"0 8px 40px rgba(0,0,0,.25)"}}>
        {/* Header */}
        <div style={{padding:"16px 20px",borderBottom:"1px solid var(--line)",
          display:"flex",alignItems:"center",gap:14}}>
          <div style={{width:56,height:56,borderRadius:"50%",overflow:"hidden",
            background:"var(--accent)",flexShrink:0,display:"flex",
            alignItems:"center",justifyContent:"center",color:"#fff",fontWeight:700,fontSize:20}}>
            {photo?<img src={photo} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}}/>
              :(name||"?").split(" ").slice(0,2).map(w=>w[0]).join("").toUpperCase()}
          </div>
          <div style={{flex:1}}>
            <div style={{fontWeight:700,fontSize:17}}>{name}</div>
            <div style={{fontSize:13,color:"var(--muted)"}}>{empId}</div>
            {data&&<div style={{fontSize:13,color:"var(--muted)"}}>{data.designation||""}{data.department?` · ${data.department}`:""}</div>}
          </div>
          <button onClick={onClose} style={{background:"none",border:"none",fontSize:24,cursor:"pointer",color:"#999",lineHeight:1}}>×</button>
        </div>
        {/* Body */}
        <div style={{flex:1,overflowY:"auto",padding:"16px 20px"}}>
          {!data?<div className="loading">Loading…</div>:(
            <>
              <div style={{fontWeight:700,fontSize:12,textTransform:"uppercase",letterSpacing:".06em",color:"var(--muted)",marginBottom:8}}>Personal</div>
              <Row label="Email" value={data.email}/>
              <Row label="Mobile" value={data.mobile}/>
              <Row label="Date of Birth" value={data.date_of_birth}/>
              <Row label="Gender" value={data.gender}/>
              <Row label="Location" value={data.location}/>
              <Row label="Marital Status" value={data.marital_status}/>
              <div style={{fontWeight:700,fontSize:12,textTransform:"uppercase",letterSpacing:".06em",color:"var(--muted)",margin:"14px 0 8px"}}>Work</div>
              <Row label="Department" value={data.department}/>
              <Row label="Designation" value={data.designation}/>
              <Row label="Date of Joining" value={data.date_of_joining}/>
              <Row label="Reporting To" value={data.reporting_to_name}/>
              <Row label="Role" value={ROLE_LABEL[data.role]||data.role}/>
              <Row label="Face Enrolled" value={data.face_enrolled?"✓ Yes":"✗ No"}/>
            </>
          )}
        </div>
        {/* Footer */}
        <div style={{padding:"12px 20px",borderTop:"1px solid var(--line)",display:"flex",gap:8}}>
          <a href={`/portal/attendance?emp=${empId}`}
            style={{flex:1,textAlign:"center",padding:"8px",borderRadius:8,
              background:"var(--soft)",border:"1px solid var(--line)",fontSize:13,
              color:"var(--ink)",textDecoration:"none",fontWeight:500}}>📅 Attendance</a>
          <a href={`/portal/history?emp=${empId}`}
            style={{flex:1,textAlign:"center",padding:"8px",borderRadius:8,
              background:"var(--soft)",border:"1px solid var(--line)",fontSize:13,
              color:"var(--ink)",textDecoration:"none",fontWeight:500}}>📋 History</a>
          <a href={`/portal/leaves?emp=${empId}`}
            style={{flex:1,textAlign:"center",padding:"8px",borderRadius:8,
              background:"var(--soft)",border:"1px solid var(--line)",fontSize:13,
              color:"var(--ink)",textDecoration:"none",fontWeight:500}}>✈ Leaves</a>
        </div>
      </div>
    </div>
  );
}

export default function Team(){
  const {me}=useAuth();
  const [members, setMembers] =useState([]);
  const [filtered,setFiltered]=useState([]);
  const [search,  setSearch]  =useState("");
  const [dept,    setDept]    =useState("");
  const [mgr,     setMgr]     =useState("");
  const [loading, setLoading] =useState(true);
  const [modal,   setModal]   =useState(null); // {empId, name}
  const navigate=useNavigate();

  useEffect(()=>{
    api.get("/portal/team")
      .then(d=>{setMembers(d.members||[]);setFiltered(d.members||[]);})
      .catch(()=>{}).finally(()=>setLoading(false));
  },[]);

  useEffect(()=>{
    let out=members;
    if(search)out=out.filter(m=>`${m.name} ${m.employee_id} ${m.designation}`.toLowerCase().includes(search.toLowerCase()));
    if(dept)out=out.filter(m=>m.department===dept);
    if(mgr) out=out.filter(m=>m.reporting_to===mgr);
    setFiltered(out);
  },[search,dept,mgr,members]);

  const depts=[...new Set(members.map(m=>m.department).filter(Boolean))].sort();
  const mgrs =[...new Set(members.map(m=>m.reporting_to).filter(Boolean))].sort();
  const isAdmin=me?.role==="admin"||me?.role==="hr"||me?.role==="manager";

  const goTo=(page,empId)=>{
    if(isAdmin&&empId!==me?.employee_id) navigate(`/portal/${page}?emp=${empId}`);
    else navigate(`/portal/${page}`);
  };

  return(
    <div>
      <h2 className="page-title">Team</h2>
      <p className="page-sub">{me?.role==="admin"?"All active employees.":"Your reportees and scoped employees."}</p>

      <div style={{display:"flex",gap:10,marginTop:16,marginBottom:20,flexWrap:"wrap",alignItems:"center"}}>
        <input className="inp" style={{minWidth:220,flex:1,maxWidth:300}} value={search}
          onChange={e=>setSearch(e.target.value)} placeholder="Search name / ID…"/>
        <select className="inp" style={{width:"auto"}} value={dept} onChange={e=>setDept(e.target.value)}>
          <option value="">All departments</option>
          {depts.map(d=><option key={d}>{d}</option>)}
        </select>
        <select className="inp" style={{width:"auto"}} value={mgr} onChange={e=>setMgr(e.target.value)}>
          <option value="">All reporting managers</option>
          {mgrs.map(m=><option key={m}>{m}</option>)}
        </select>
      </div>

      {loading&&<div className="loading">Loading…</div>}
      {!loading&&<>
        <div style={{fontSize:13,color:"var(--muted)",marginBottom:12}}>
          {filtered.length} employee{filtered.length!==1?"s":""}
        </div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(300px,1fr))",gap:14}}>
          {filtered.map(m=>{
            const rc=ROLE_COLORS[m.role]||ROLE_COLORS.team_member;
            return(
              <div key={m.employee_id}
                style={{background:"var(--panel)",border:"1px solid var(--line)",
                  borderRadius:14,padding:"16px 16px 12px",transition:"box-shadow .15s"}}
                onMouseEnter={e=>e.currentTarget.style.boxShadow="0 4px 16px rgba(27,36,55,.08)"}
                onMouseLeave={e=>e.currentTarget.style.boxShadow="none"}>
                <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:10}}>
                  <TeamAvatar emp={m}/>
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{fontWeight:700,fontSize:14.5,lineHeight:1.2}}>{m.name}</div>
                    <div style={{fontSize:12,color:"var(--muted)",marginTop:2}}>
                      {m.employee_id}{m.designation?` · ${m.designation}`:""}
                    </div>
                  </div>
                  <span style={{fontSize:11,fontWeight:600,padding:"3px 8px",borderRadius:12,flexShrink:0,
                    background:m.face_enrolled?"#DCFCE7":"var(--soft)",
                    color:m.face_enrolled?"#166534":"var(--muted)"}}>
                    {m.face_enrolled?"✓ Face":"No face"}
                  </span>
                </div>
                <div style={{display:"flex",flexWrap:"wrap",gap:6,marginBottom:10}}>
                  {m.department&&<span style={{fontSize:12,padding:"3px 9px",borderRadius:20,background:"var(--soft)",color:"var(--muted)"}}>🏢 {m.department}</span>}
                  <span style={{fontSize:12,padding:"3px 9px",borderRadius:20,fontWeight:600,background:rc.bg,color:rc.color}}>{ROLE_LABEL[m.role]||m.role}</span>
                  {m.reporting_to&&<span style={{fontSize:12,padding:"3px 9px",borderRadius:20,background:"#F0FDF4",color:"#166534"}}>↑ {m.reporting_to}</span>}
                </div>
                <div style={{display:"flex",gap:5,flexWrap:"wrap",paddingTop:8,borderTop:"1px solid var(--line)"}}>
                  {[
                    ["👤 Profile",  ()=>setModal({empId:m.employee_id,name:m.name})],
                    ["📅 Attend.",  ()=>goTo("attendance",m.employee_id)],
                    ["📋 History",  ()=>goTo("history",m.employee_id)],
                    ["✈ Leaves",   ()=>goTo("leaves",m.employee_id)],
                  ].map(([label,action])=>(
                    <button key={label} onClick={action}
                      style={{background:"var(--soft)",border:"1px solid var(--line)",borderRadius:8,
                        padding:"5px 10px",fontSize:12,cursor:"pointer",color:"var(--ink)",fontWeight:500,transition:"all .12s"}}
                      onMouseEnter={e=>{e.currentTarget.style.background="var(--accent)";e.currentTarget.style.color="#fff";e.currentTarget.style.borderColor="var(--accent)";}}
                      onMouseLeave={e=>{e.currentTarget.style.background="var(--soft)";e.currentTarget.style.color="var(--ink)";e.currentTarget.style.borderColor="var(--line)";}}>
                      {label}
                    </button>
                  ))}
                </div>
              </div>
            );
          })}
          {!filtered.length&&<div style={{gridColumn:"1/-1",textAlign:"center",color:"var(--muted)",padding:40}}>No employees match the current filters.</div>}
        </div>
      </>}

      {modal&&<EmpProfileModal empId={modal.empId} name={modal.name} onClose={()=>setModal(null)}/>}
    </div>
  );
}
